'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _translate = require('../../language/translate');

function isMultiTrip(values) {
  return values.application.additional_data.policy_type === 'multi-trip annual';
}

/**
 * Validates the values in the Get Quote portion of the form (the first page).
 * @param {Object} values - The values in the form to validate.
 * @returns {Object} Object of errors found in the form.
 */

exports.default = function (values, props) {
  return {
    applicant: values.applicant.map(function (applicant, i) {
      return {
        dob: !applicant.dob,
        first_name: !applicant.first_name,
        last_name: !applicant.last_name,
        email: i === 0 && !applicant.email,
        additional_data: {
          relationship_to_primary_applicant: i > 0 && !applicant.additional_data.relationship_to_primary_applicant
        }
      };
    }),
    application: {
      effective_date: !values.application.effective_date,
      expiry_date: !isMultiTrip(values) && !values.application.expiry_date,
      additional_data: {
        eligibility: !values.application.additional_data.eligibility,
        membership_number: !values.application.additional_data.membership_number,
        province_of_residence: ['CA', 'US'].includes(values.application.additional_data.country_of_origin) && !values.application.additional_data.province_of_residence,
        policy_type: !values.application.additional_data.policy_type,
        trip_cost: !isMultiTrip(values) && (!values.application.additional_data.trip_cost || values.application.additional_data.trip_cost && values.application.additional_data.trip_cost.replace(/\$/g, '').replace(/,/g, '') > 30000),
        trip_booked_date: !values.application.additional_data.trip_booked_date,
        destination: values.application.additional_data.country_of_origin === 'CA' && !isMultiTrip(values) && !values.application.additional_data.destination,
        country_of_origin: !values.application.additional_data.country_of_origin,
        cancel_delux: !values.application.additional_data.cancel_delux
      }
    },
    errors: props.application.quote.information && Array.isArray(props.application.quote.information)
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/all-inclusive/Quote.js
// module id = 1746
// module chunks = 0